import React, { useState } from 'react';
import { PaymentModal } from './PaymentModal';
import './BuyCreditsButton.css';

export const BuyCreditsButton = ({ className = '' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        className={`buy-credits-button ${className}`}
        onClick={() => setIsModalOpen(true)}
      >
        Купить
      </button>

      <PaymentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}; 